import * as React from "react";
import { User } from "../../session/types";
import ErrorMessage from "../../../components/ErrorMessage";

interface OwnProps {
  user: User | null;
}

type Props = OwnProps;

export default (props: Props) => {
  const name = props.user ? props.user?.firstName + " " + props.user?.lastName : null;
  return (
    <div>
      <ErrorMessage message={`No organizations found for user ${name}`} />
      <div className="mt-10 center">Please contact your administrator.</div>
    </div>
  );
};
